import { styled, Flex } from '@withjoy/joykit';

export const StyledFlex = styled(Flex)`
  flex-direction: column-reverse;
  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

export const StyledFlexFooter = styled(Flex)`
  column-gap: 8px;
  row-gap: 8px;
`;
